(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


const findHeaderCandidates = () => {
  // Include anything that could sit at the top and overlap content
  return [
    document.querySelector('sticky-header'),
    document.querySelector('[data-header]'),
    document.querySelector('#shopify-section-header'),
    document.querySelector('header'),
    document.querySelector('.announcement-bar'),
  ].filter(Boolean);
};

let rafId = null;

const setFiltersStickyTop = () => {
  rafId = null;

  const candidates = findHeaderCandidates();
  if (!candidates.length) {
    document.documentElement.style.setProperty('--filters-sticky-top', '0px');
    return;
  }

  // We use the *largest* bottom edge among visible, top-overlapping bars.
  // This automatically adapts if the header collapses/expands or toggles sticky on scroll.
  let maxBottom = 0;

  for (const el of candidates) {
    const rect = el.getBoundingClientRect();

    // If it's not on screen, it can't cover anything
    if (rect.bottom <= 0) continue;

    const pos = getComputedStyle(el).position;

    // If it’s fixed/sticky, it can overlap while scrolling.
    // Some themes temporarily set position relative; rect.bottom will still be correct at top,
    // and during scroll rect.bottom will go <= 0 when it scrolls away, which is what we want.
    if (pos === 'fixed' || pos === 'sticky' || rect.top <= 0) {
      maxBottom = Math.max(maxBottom, rect.bottom);
    }
  }

  const topPx = Math.max(0, Math.ceil(maxBottom));
  document.documentElement.style.setProperty('--filters-sticky-top', `${topPx}px`);
};

const requestSetFiltersStickyTop = () => {
  if (rafId) return;
  rafId = requestAnimationFrame(setFiltersStickyTop);
};

document.addEventListener(
  'DOMContentLoaded',
  () => {
    requestSetFiltersStickyTop();

    window.addEventListener('scroll', requestSetFiltersStickyTop, { passive: true });
    window.addEventListener('resize', requestSetFiltersStickyTop, { passive: true });

    // React to header height changes (announcement bar appearing, condensed header, etc.)
    const ro = new ResizeObserver(requestSetFiltersStickyTop);
    findHeaderCandidates().forEach((el) => ro.observe(el));

    // React to class/DOM changes that might affect header layout
    const mo = new MutationObserver(requestSetFiltersStickyTop);
    mo.observe(document.documentElement, { attributes: true, childList: true, subtree: true });
  },
  { once: true }
);

  } catch(e) { console.error(e); }
})();
})();
